import Header from "../../common/Header";

import React, { useEffect } from "react";
import ContractListDataGrid from "../ContractListDataGrid";
import ProjectAssignment from "./ProjectAssignment";

import "./index.css";
import { useDispatch, useSelector } from "react-redux";

export default function ProjectAssign() {
  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Project Assign";

    // if (userInfo.employeeNo == null) {
    // dispatch(updateLoginPopupVisible(true));
    // }
  });
  return (
    <React.Fragment>
      {/* <Header title="Project Assign" /> */}
      {userInfo.employeeNo && (
        <ContractListDataGrid path="PrjAsgmt" title="PROJECT INFORMATION" />
      )}

      {/* <ProjectAssignment /> */}
    </React.Fragment>
  );
}
